<template>
  <div class="select-options_loading">
    <SkeletonLoader
      v-for="i in 5"
      :key="i"
      class="select-options__skeleton-item"
      width="100%"
      height="12px"
      :is-loading="true"
    />
  </div>
</template>

<script>
  import SkeletonLoader from 'components/common/SkeletonLoader';

  export default {
    name: 'MSelectControlSkeletonLoader',
    components: {SkeletonLoader}
  };
</script>

<style>
  .select-options_loading {
    padding: 8px;
  }
</style>
